(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _MainNavigationSubmenu = _interopRequireDefault(require("./MainNavigationSubmenu.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  links: _propTypes.array
};

var MainNavigation = function MainNavigation(props) {
  var links = props.links;

  if (!links || links.length < 1) {
    return null;
  }

  var handleClose = function handleClose(e) {
    document.querySelector("body").classList.remove("active-nav");
  };

  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "main-navigation__nav"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "main-navigation__close-button",
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement("span", null, "Close")), /*#__PURE__*/_react.default.createElement("ul", {
    className: "main-navigation__link-list"
  }, links.map(function (link, i) {
    var hasMenu = link.submenu && link.submenu.length > 0;
    return hasMenu ? /*#__PURE__*/_react.default.createElement(_MainNavigationSubmenu.default, _extends({}, link, {
      topLevel: true,
      key: i
    })) : /*#__PURE__*/_react.default.createElement("li", {
      className: "main-navigation__item",
      key: i,
      "data-title": link.text
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "main-navigation__row"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "main-navigation__link " + (window.location.href.replace(window.location.origin, '') == link.href ? 'main-navigation__link-active' : ''),
      href: link.href
    }, link.text)));
  })));
};

MainNavigation.propTypes = propTypes;
var _default = MainNavigation;
exports.default = _default;

},{"./MainNavigationSubmenu.jsx":2,"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var propTypes = {
  text: _propTypes.string,
  href: _propTypes.string,
  submenu: _propTypes.array
};

var MainNavigationSubmenu = function MainNavigationSubmenu(props) {
  var text = props.text,
      href = props.href,
      submenu = props.submenu;

  var _useState = (0, _react.useState)(window.location.href.indexOf(href) > -1),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  if (!submenu || submenu.length < 1) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    className: "main-navigation__item",
    "data-title": text
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "main-navigation__row"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _classnames.default)("main-navigation__link", {
      "main-navigation__link--expanded": isOpen
    }) + (window.location.href.replace(window.location.origin, '') == href ? ' main-navigation__link-active' : ''),
    href: href
  }, text), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "main-navigation__toggle-button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    "aria-expanded": isOpen
  }, /*#__PURE__*/_react.default.createElement("span", null, "Toggle Accordion"))), isOpen && /*#__PURE__*/_react.default.createElement("ul", {
    className: "main-navigation__submenu-list"
  }, submenu.map(function (menu, i) {
    var hasMenu = menu.submenu && menu.submenu.length > 0;
    return hasMenu ? /*#__PURE__*/_react.default.createElement(MainNavigationSubmenu, _extends({}, menu, {
      key: i
    })) : /*#__PURE__*/_react.default.createElement("li", {
      className: "main-navigation__item",
      "data-title": menu.text,
      key: i
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "main-navigation__row"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "main-navigation__link " + (window.location.href.replace(window.location.origin, '') == menu.href ? 'main-navigation__link-active' : ''),
      "data-title": menu.text,
      href: menu.href
    }, menu.text)));
  })));
};

MainNavigationSubmenu.propTypes = propTypes;
var _default = MainNavigationSubmenu;
exports.default = _default;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],3:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _MainNavigation = _interopRequireDefault(require("../components/MainNavigation/MainNavigation.jsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// import mockData from "../components/MainNavigation/mockData.js";
document.addEventListener("DOMContentLoaded", function () {
  _toConsumableArray(document.querySelectorAll(".js-main-navigation-mount")).forEach(function (mount) {
    var data = JSON.parse(mount.dataset.model) || {}; // const data = mockData;

    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_MainNavigation.default, data), mount);
  });
});

},{"../components/MainNavigation/MainNavigation.jsx":1,"react":"react","react-dom":"react-dom"}]},{},[3]);
